import {createContext} from 'react';

export const HeaderHeightContext = createContext({
  headerHeight: 0,
  // eslint-disable-next-line no-unused-vars
  setHeaderHeight: (_height: number): void => {},
});
